export enum PricePlans {
  Free = 'Free',
  VerificationPlus = 'Verification Plus',
  Assist = 'Assist',
  Pro = 'Pro',
}

const knownPricePlans: string[] = Object.values(PricePlans);

export const resolvePricePlan = (name: string | null | undefined): PricePlans =>
  name && knownPricePlans.includes(name) ? (name as PricePlans) : PricePlans.Free;
